'use strict';
var modalMessage = require('../modalMessage.js');

$(document).on('click', '.add-store-non-login', function(){
    $('.add-wp-extend.extended').removeClass('extended');
    var redirect = window.location.href;
        var url = $(this).data('url');
        $('.wishlist_redirect_login').attr('href',url+'?redirect='+redirect);
    $(this).siblings('.add-wp-extend').css({'width': '0','position':'absolute'});
    $(this).siblings('.add-wp-extend').addClass('extended');
    // $('.header_brand').addClass('mb5r');
    $('body').click(function(e){
        $('.add-wp-extend.extended').removeClass('extended');
    })
} )


$(function () {
    $('.office_edit_btn').on('click', async function () {
        var ids = checkboxWishList().ids;
        var id_coordinate_staff = checkboxWishList().id_coordinate_staff;
        var url = $(this).closest(".tab__item").data('url');
        var action =  'remove';
        var $this = $(this);
        var $parent = $this.closest('.tab-item');
        var tabname = $(this).closest(".tab-item").data("tabname")
        var $parentBtn = $this.parent();
        var imageClose = $this.data("imageurl");
        $parent.addClass('is-edit');
        $parentBtn.children('.office-cancel-edit-btn').removeClass('d-none');
        $parentBtn.children('.back-btn').addClass('d-none').removeClass('pc-display');
        $(".btn-to-edit").addClass('d-none');
        $(".btn-to-delete").removeClass('d-none');
        var getCurrentpage = parseInt($(".hidden__currentpage").val());
        if(ids.length > 0) {
            ids = ids.toString();
            id_coordinate_staff = id_coordinate_staff.toString();
            $.ajax({
                url: url,
                method: 'POST',
                data: {sid: ids, id_coordinate_staff: id_coordinate_staff, action: action},
                success: function (response) {
                    if (response.error) {
                        modalMessage.displayModalMessage(response.msg,imageClose);
                    } else {
                        var tempPage = "page=" + getCurrentpage;
                        var currentTempPage = "page=" + response.reloadCurrentPage;
                        var regexUrl = window.location.href.replace(tempPage, currentTempPage);
                        location.href = regexUrl;
                    }
                }
            });
        }
    })
  
    $('.office-cancel-edit-btn').on('click', function () {
        $(".checked-remove-wishlist").prop('checked',false);
        var $this = $(this);
        var $parent = $this.closest('.tab-item');
        var $parentBtn = $this.parent();
        $parent.removeClass('is-edit');
        $this.addClass('d-none');
        $parentBtn.children('.back-btn').removeClass('d-none');
        $(".btn-to-edit").removeClass('d-none');
        $(".btn-to-delete").addClass('d-none');

    })
})

function checkboxWishList() {
    var cbWishlist = $('.checked-remove-wishlist');
    var ids = [];
    var id_coordinate_staff = [];
    if(cbWishlist.length > 0) {
        $(cbWishlist).each(function( index , el) {
            if(el.checked == true) {
                var sid = $(el).data('sid');
                ids.push(sid);
                id_coordinate_staff.push($(el).data('id-staff-coordinate'));
            }
        });
    }
    return {ids: ids, id_coordinate_staff: id_coordinate_staff};
}

module.exports = {
    addOrRemoveWishList: function () {
        $(document).on('click','.wishList-container img, .wishList-container .hide_store, .wishList-container-detail', function () {
            var element = $(this);
            var action = element.data('action');
            var pid = element.data('pid');
            var sid = element.data('sid');
            var name = element.data('name');
            var type = element.data('type');
            var triggerBtn = element.data('trigger');
            var form = {};
            var popup = $(this).siblings('.popup-add');
            var HeaderDataLayer = $('input[name="dataLayer"]').val();
            if(element.hasClass('wishList-container-detail'))  {
                $(this).css('pointer-events', 'none');
            }
            if (element.hasClass('img-notchoice') || element.hasClass('img-choice')) {
                element.parent().css('pointer-events', 'none');
            }
            if (HeaderDataLayer) {
                HeaderDataLayer = JSON.parse(HeaderDataLayer);
            }
            if(type == "STAFFCOORDINATE") {
                form = {
                    pid: pid,
                    sid: sid,
                    name : name
                }
            } else {
                if (pid) {
                    form = {
                        pid: element.data('pid')
                    };
                } else if (sid) {
                    form = {
                        sid: element.data('sid')
                    };
                }
            }

            if(action) {
                form.action = action;
            }

            var url = element.data('url');
            var imageClose = $('.recommend-block__icon , .add-wp-btn').data("imageurl");
            if (action === 'add') {
                $.ajax({
                    url: url,
                    method: 'POST',
                    data: form,
                    success: function (response) {
                        if (response.error) {

                            if (response.msg == "itemExists") {
                                return;
                            }

                            $(".wp-modal").removeClass('modal-fade');
                            if(response.status == 0) {
                                element.find(".add-staff-extend").addClass("extended");
                                return;
                            }

                            if(element.hasClass('wishList-container-detail'))  {
                                element.css('pointer-events', 'auto');
                            }
                            if (element.hasClass('img-notchoice') || element.hasClass('img-choice')) {
                                element.parent().css('pointer-events', 'auto');
                            }
                            modalMessage.displayModalMessage(response.msg,imageClose);
                        } else if (response.type === 'store') {
                            $('.box-' + sid + '-add-wishlist').removeClass('d-block').addClass('d-none');
                            $('.box-' + sid + '-remove-wishlist').addClass('d-block').removeClass('d-none');
                            const popup_store = $('.store_'+sid) ;
                            popup_store.html('お気に入りストアタイプに登録しました');
                            popup_store.toggleClass('added');
                            // $('.header_brand').addClass('mb5r');
                            setTimeout(function () {
                                popup_store.removeClass('added');
                                // $('.header_brand').removeClass('mb5r');
                            }, 1000);
                            //datalayer
                            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                            dataLayer.push({
                                user_id: HeaderDataLayer && HeaderDataLayer.user_properties ? HeaderDataLayer.user_properties.customer_id : '',
                                event: "add_to_wishlist_storetype",
                                ecommerce: {
                                    currency: 'JPY',
                                    items: response.items
                                }
                            });
                        } else {

                            if(response.status == 1) {
                                $(".add-staff-extend").removeClass("extended");
                                return;
                            }

                            if(element.hasClass('wishList-container-detail'))  {
                                var changeAction = action == "add" ? "remove" : "add";
                                element.data('action', changeAction);
                                if (triggerBtn && triggerBtn !== '') {
                                    $(`.${triggerBtn}`).data('action', changeAction);
                                }
                            }

                            $('#img-' + pid + '-add-wishlist').removeClass('d-block').addClass('d-none');
                            $('#img-' + pid + '-remove-wishlist').addClass('d-block').removeClass('d-none');
                            $('.img-' + pid + '-add-wishlist-group').removeClass('d-block').addClass('d-none');
                            $('.img-' + pid + '-remove-wishlist-group').addClass('d-block').removeClass('d-none');
                            if(response.queryString !== 'type=styling' && response.queryString !== 'type=staff'){
                                var idWishlist = 11;
                                if (response.grouping == 0) {
                                    idWishlist = 13;
                                }
                                $('.recommend_no_' + response.pid.slice(0,idWishlist)).addClass('d-none').removeClass('d-block');
                                $('.recommend_yes_' + response.pid.slice(0,idWishlist)).addClass('d-block').removeClass('d-none');

                            }
                            $('#wishlist-group-add-' + pid.toString().slice(0,13)).removeClass('d-block').addClass('d-none');
                            $('#wishlist-group-remove-' + pid.toString().slice(0,13)).addClass('d-block').removeClass('d-none');

                            $('.img-' + pid + '-add-wishlist').removeClass('d-block').addClass('d-none');
                            $('.img-' + pid + '-remove-wishlist').addClass('d-block').removeClass('d-none');

                            $('.wishlist_total').text(response.amount);
                            var text = 'お気に入りアイテムに登録しました';
                            if (response.queryString.indexOf('styling') > 0) {
                                text = 'お気に入りスタイリングに登録しました';
                            } else if (response.queryString.indexOf('type=staff') > -1) {
                                text = 'お気に入りスタッフに登録しました';
                            }
                            popup.find('.content-popup-add').html(text);
                            popup.toggleClass('added');
                            setTimeout(function () {
                            popup.removeClass('added');
                            }, 1000);
                            if(type == "STAFFCOORDINATE" && response.data != null) {
                                $('.img-' + pid + '-remove-wishlist').data("sid", response.data[0]._id);
                                $('.img-' + pid + '-add-wishlist').data("sid", response.data[0]._id);
                                $('.img-' + pid + '-remove-wishlist').attr("data-sid", response.data[0]._id);
                                $('.img-' + pid + '-add-wishlist').attr("data-sid", response.data[0]._id);
                                element.data('sid', response.data[0]._id);
                                if (triggerBtn && triggerBtn !== '') {
                                    $(`.${triggerBtn}`).data('sid', response.data[0]._id);
                                }

                                if (triggerBtn == 'trigger-child-btn') {
                                    $(`.${triggerBtn}`).toggleClass('change__text');
                                    $(`.${triggerBtn}`).css('pointer-events', 'auto');
                                }
                                //datalayer
                                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                                dataLayer.push({
                                    user_id: HeaderDataLayer && HeaderDataLayer.user_properties ? HeaderDataLayer.user_properties.customer_id : '',
                                    event: response.queryString === 'type=styling' ? "add_to_wishlist_styling" : "add_to_wishlist_staff",
                                    ecommerce: {
                                        currency: 'JPY',
                                        items: response.items
                                    }
                                });  
                            }
                        }
                        if (response.success && element.hasClass('position__change')) {
                            element.toggleClass('change__text');
                            element.css('pointer-events', 'auto');
                        }

                        if (response.success && (element.hasClass('img-notchoice') || element.hasClass('img-choice'))) {
                            element.parent().css('pointer-events', 'auto');
                        }
                        //datalayer
                        if(!type && !response.type){
                            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                            dataLayer.push({
                            user_id: HeaderDataLayer && HeaderDataLayer.user_properties ? CryptoJS.SHA256(HeaderDataLayer.user_properties.customer_id).toString(CryptoJS.enc.Hex) : '',
                            members_id: HeaderDataLayer && HeaderDataLayer.user_properties ? HeaderDataLayer.user_properties.customer_id : '',
                            event: 'add_to_wishlist',
                            ecommerce: {
                                currency: 'JPY',
                                value: response.value,
                                items: response.items
                            }
                            });
                        }
                    },
                });
            } else {
                $.ajax({
                    url: url,
                    method: 'POST',
                    data: form,
                    success: function (response) {
                        if (response.error) {
                            if(response.status == 0) {
                                $(".add-staff-extend").addClass("extended");
                                return;
                            }
                            if(element.hasClass('wishList-container-detail'))  {
                                element.css('pointer-events', 'auto');
                            }
                            if (element.hasClass('img-notchoice') || element.hasClass('img-choice')) {
                                element.parent().css('pointer-events', 'auto');
                            }
                            modalMessage.displayModalMessage(response.msg,imageClose);
                        } else if (response.type === 'store') {
                            $('.box-' + sid + '-remove-wishlist').removeClass('d-block').addClass('d-none');
                            $('.box-' + sid + '-add-wishlist').addClass('d-block').removeClass('d-none');
                            const popup_store = $('.store_'+sid) ;
                            popup_store.html('お気に入りストアタイプから削除しました');
                            popup_store.toggleClass('added');
                            // $('.header_brand').addClass('mb5r');
                            setTimeout(function () {
                                popup_store.removeClass('added');
                                // $('.header_brand').removeClass('mb5r');
                            }, 1000);
                        } else {

                            if(response.status == 1) {
                                $(".add-staff-extend").removeClass("extended");
                                return;
                            }

                            if(element.hasClass('wishList-container-detail'))  {
                                var changeAction = action == "add" ? "remove" : "add";
                                element.data('action', changeAction);
                                if (triggerBtn && triggerBtn !== '') {
                                    $(`.${triggerBtn}`).data('action', changeAction);
                                }
                            }

                            if(response.isRemoveAll && (response.queryString != 'type=styling' || response.queryString !== 'type=staff')){
                                var idWishlist = 11;
                                if ( response.grouping == 0) {
                                    idWishlist = 13;
                                }
                                $('.recommend_yes_' + response.pid.slice(0,idWishlist)).addClass('d-none').removeClass('d-block');
                                $('.recommend_no_' + response.pid.slice(0,idWishlist)).addClass('d-block').removeClass('d-none');
                            }

                            if(response.isRemoveGroupAll){
                                $('#wishlist-group-remove-' + pid.toString().slice(0,13)).removeClass('d-block').addClass('d-none');
                                $('#wishlist-group-add-' + pid.toString().slice(0,13)).addClass('d-block').removeClass('d-none');
                            }

                            $('.img-' + pid + '-remove-wishlist').removeClass('d-block').addClass('d-none');
                            $('.img-' + pid + '-add-wishlist').addClass('d-block').removeClass('d-none');

                            $('#img-' + pid + '-remove-wishlist').removeClass('d-block').addClass('d-none');
                            $('#img-' + pid + '-add-wishlist').addClass('d-block').removeClass('d-none');
                            $('.img-' + pid + '-remove-wishlist-group').removeClass('d-block').addClass('d-none');
                            $('.img-' + pid + '-add-wishlist-group').addClass('d-block').removeClass('d-none');
                            $('.wishlist_total').text(response.amount);
                            var text = 'お気に入りアイテムから削除しました';
                            if (response.queryString.indexOf('styling') > 0) {
                                text = 'お気に入りスタイリングから削除しました';
                            } else if (response.queryString.indexOf('type=staff') > -1) {
                                text = 'お気に入りスタッフから削除しました';
                            }
                            popup.find('.content-popup-add').html(text);
                            popup.toggleClass('added');
                            setTimeout(function () {
                            popup.removeClass('added');
                            }, 1000);
                        }
                        if (response.success && element.hasClass('position__change')) {
                            element.toggleClass('change__text');
                            element.css('pointer-events', 'auto');
                        }

                        if (response.success && (element.hasClass('img-notchoice') || element.hasClass('img-choice'))) {
                            element.parent().css('pointer-events', 'auto');
                        }

                        if (triggerBtn && triggerBtn !== '') {
                            $(`.${triggerBtn}`).toggleClass('change__text');
                            $(`.${triggerBtn}`).css('pointer-events', 'auto');
                        }
                    }
                });
            }
        });
    },
   
};
